import { render } from "./AllBorrowers.vue?vue&type=template&id=40d7fe06&scoped=true"
import script from "./AllBorrowers.vue?vue&type=script&lang=js"
export * from "./AllBorrowers.vue?vue&type=script&lang=js"

import "./AllBorrowers.vue?vue&type=style&index=0&id=40d7fe06&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d7fe06"]])

export default __exports__